import {axios as http} from "@/plugins/http"

export default class Api {
    static themes(limit) {
        let config = {
            params: {
                limit: limit,
            },
        }

        return http.get("/api/v1/wishlist/themes", config).then((resp) => {
            return resp.data["items"]
        })
    }
}
